const getWhitelistData = (t) => {
  const whitelistColumns = [
    {
      Header: t("whitelist.ip"),
      accessor: "ipAddress",
      sortable: true,
    },
    {
      Header: t("whitelist.active"),
      accessor: "active",
      sortable: true,
      Cell: ({ row }) => <>{row.original.active ? "Yes" : "No"}</>,
    },
    {
      Header: t("whitelist.createdAt"),
      accessor: "createdAt",
      sortable: true,
    },
    {
      Header: t("whitelist.updatedAt"),
      accessor: "updatedAt",
      sortable: true,
    },
    {
      Header: t("whitelist.lastUsed"),
      accessor: "lastUsed",
      sortable: true,
    },
  ];

  return { whitelistColumns };
};

export default getWhitelistData;
